<div class="so-row-actions-menu">
  <button
    #trigger
    type="button"
    class="so-row-actions-trigger"
    cdkOverlayOrigin
    #origin="cdkOverlayOrigin"
    [attr.aria-label]="title() || 'Más acciones'"
    aria-haspopup="menu"
    [attr.aria-expanded]="isOpen()"
    (click)="toggleMenu($event)">
    <svg class="so-row-actions-kebab" viewBox="0 0 24 24" width="16" height="16" aria-hidden="true">
      <circle cx="12" cy="5" r="2" fill="currentColor" />
      <circle cx="12" cy="12" r="2" fill="currentColor" />
      <circle cx="12" cy="19" r="2" fill="currentColor" />
    </svg>
  </button>

  <ng-template
    cdkConnectedOverlay
    [cdkConnectedOverlayOrigin]="origin"
    [cdkConnectedOverlayOpen]="isOpen()"
    [cdkConnectedOverlayPositions]="overlayPositions"
    [cdkConnectedOverlayHasBackdrop]="true"
    [cdkConnectedOverlayBackdropClass]="'cdk-overlay-transparent-backdrop'"
    (backdropClick)="closeMenu()"
    (detach)="closeMenu()">
    <div class="so-row-actions-panel" role="menu" (keydown)="onPanelKeydown($event)">
      @for (action of visibleActions(); track $index) {
        <button
          type="button"
          role="menuitem"
          class="so-row-actions-item"
          [class.danger]="action.variant === 'danger'"
          [disabled]="isDisabled(action)"
          [attr.aria-disabled]="isDisabled(action)"
          [attr.aria-label]="action.text || getTooltip(action)"
          [title]="getTooltip(action)"
          (click)="onActionClick(action, $event)">
          <so-svg-icon-ui
            [name]="action.svg || action.icon || 'content-copy'"
            [color]="action.color || (action.variant === 'danger' ? '--so-danger' : '--so-secondary')"
            [size]="16" />
          @if (action.text) {
            <span>{{ action.text }}</span>
          }
        </button>
      }
    </div>
  </ng-template>
</div>
